import getProp from '@f/get-prop'

export function getMTUsForPast30Days (state, slug) {
  return state.mtus.last30Days.data[slug]
}

export function getMTUCountForPast30Days (state, slug) {
  const mtus = getMTUsForPast30Days(state, slug) || {}
  const { anonymous = 0, users = 0 } = getProp('data.counts', mtus) || {}
  return anonymous + users
}

export function getMTUsForPastXMonths (state, slug, monthsAgo) {
  const key = `${slug}:${monthsAgo}`
  return state.mtus.pastXMonths[key]
}

export function getBillingCountForPastXMonths (state, slug, monthsAgo) {
  const mtus = getMTUsForPastXMonths(state, slug, monthsAgo) || {}
  const data = mtus.data && mtus.data.length ? mtus.data : []
  let counts = data.map(month => {
    return {
      anonymous: month.counts.anonymous || 0,
      objects: month.counts.objects || 0,
      users: month.counts.users || 0
    }
  })
  if (counts.length === 1) counts = counts[0]
  return counts
}

export function getMTUsForCurrentPeriod (state, slug) {
  return state.mtus.currentPeriod.data[slug]
}

export function getMTUsBySourceForCurrentPeriod (state, workspaceSlug) {
  return getProp(`mtus.bySourceForCurrentPeriod.${workspaceSlug}`, state)
}

export function getMTUsForCurrentPeriodBySourceId (state, workspaceSlug, sourceId) {
  const { data = [] } = getMTUsBySourceForCurrentPeriod(state, workspaceSlug) || {}
  return data.find(mtus => mtus.project_id === sourceId)
}

export function getBillingCountForCurrentPeriod (state, slug) {
  const mtus = getMTUsForCurrentPeriod(state, slug) || {}
  return getProp('data.counts', mtus) || { anonymous: 0, users: 0 }
}



// WEBPACK FOOTER //
// ./selectors/mtus.js